import React, { useState } from 'react';

function StepSix({ formData, onNext }) {
    const [dbsUpdateRegistered, setDbsUpdateRegistered] = useState(formData.dbsUpdateRegistered || '');
    const [dbsUpdateDetails, setDbsUpdateDetails] = useState(formData.dbsUpdateDetails || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!dbsUpdateRegistered) {
            setError('Please select Yes or No.');
            return;
        }

        if (dbsUpdateRegistered === 'yes' && !dbsUpdateDetails.trim()) {
            setError('Please provide details for your DBS Update registration.');
            return;
        }

        setError('');
        onNext({ dbsUpdateRegistered, dbsUpdateDetails });
    };

    const isFormValid =
        dbsUpdateRegistered === 'no' ||
        (dbsUpdateRegistered === 'yes' && dbsUpdateDetails.trim());

    return (
        <div className="step-form">
            <h6 className="mb-4">DBS Information</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>Are you registered with the DBS Update service? <span className="text-danger">*</span></p>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="dbsUpdate"
                            id="dbsUpdateYes"
                            value="yes"
                            checked={dbsUpdateRegistered === 'yes'}
                            onChange={() => setDbsUpdateRegistered('yes')}
                        />
                        <label className="form-check-label" htmlFor="dbsUpdateYes">
                            Yes
                        </label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="dbsUpdate"
                            id="dbsUpdateNo"
                            value="no"
                            checked={dbsUpdateRegistered === 'no'}
                            onChange={() => setDbsUpdateRegistered('no')}
                        />
                        <label className="form-check-label" htmlFor="dbsUpdateNo">
                            No
                        </label>
                    </div>
                </div>
            </div>

            {dbsUpdateRegistered === 'yes' && (
                <div className="mb-3">
                    <textarea
                        className="form-control"
                        placeholder="Please provide details"
                        rows="4"
                        value={dbsUpdateDetails}
                        onChange={e => setDbsUpdateDetails(e.target.value)}
                    />
                </div>
            )}

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepSix;
